export function Spinner({ label = "Loading…" }: { label?: string }) {
  return (
    <div className="acx__status-hero" role="status" aria-live="polite">
      <div className="acx__status-spinner" aria-hidden />
      <p className="acx__status-text">{label}</p>
    </div>
  );
}
